import { init } from '../../profile/manage';
import * as signinWidget from '../../signin-widget';

export function initManage(oktaAuth){
  init(signinWidget.getLoginContainerData(), oktaAuth);
}
